import { useLocalObservable } from 'mobx-react-lite';

import { Call } from '@gem/call/CallStore/Call';
import { CallSelectMemberPopup } from '@gem/call/popups/Permissions/CallSelectMemberPopup/CallSelectMemberPopup';
import { PopupStore, popupsTasks } from '@gem/popups';

import { ICallAddCustomPermissionsLinkProps } from './CallAddCustomPermissionsLink.types';

interface ICallAddCustomPermissionsLinkPresenter {
  ongoingCall: Call;
  childPopup: PopupStore | null;
  onClick(): void;
  onClose(): void;
}

export const useCallAddCustomPermissionsLinkPresenter = (
  props: ICallAddCustomPermissionsLinkProps
): ICallAddCustomPermissionsLinkPresenter => {
  const presenter = useLocalObservable<ICallAddCustomPermissionsLinkPresenter>(() => ({
    childPopup: null,

    get ongoingCall(): Call {
      return props.call;
    },

    onClose(): void {
      props.onClose?.();
    },

    onClick(): void {
      props.popupInstance.hide();
      presenter.childPopup = popupsTasks.openPopup(CallSelectMemberPopup, {
        onClose: () => presenter.onClose(),
        onBack: () => props.popupInstance.show(),
        params: {
          callController: props.callController,
          call: props.call,
        },
      });
    },
  }));

  return presenter;
};
